module.exports = __webpack_public_path__ + "static/media/meinhardt-ireland.56fa8c22.jpg";